import React from 'react';
import { AGENT } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const About = () => {
  return (
    <section
      data-testid={LANDING.about}
      className="bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="bayleys-divider mb-6" />
          <p className="text-xs tracking-[0.3em] uppercase text-bayleys-navy/70 font-medium mb-5">
            About
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-bayleys-navy leading-[1.05] tracking-tight">
            A disciplined<br />approach to<br />
            <span className="italic font-medium">selling well.</span>
          </h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 space-y-6 text-bayleys-navy/85 text-base sm:text-lg leading-relaxed font-normal">
          {AGENT.bio.map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}

          <div className="pt-4 flex items-center gap-3 text-sm text-bayleys-navy/70">
            <span className="text-xs tracking-widest uppercase font-medium text-bayleys-navy">
              {AGENT.office.legal}
            </span>
            <span className="text-bayleys-navy/30">/</span>
            <span className="text-xs tracking-widest uppercase">
              {AGENT.office.licence}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
